export default "__VITE_ASSET__DU6NSyRr__"